export const HOST_PATH: string = 'https://zmedia.xyz';
export const API_PATH: string = `${HOST_PATH}/api/`;